import PropTypes from 'prop-types';
import { useState } from 'react';
import { useI18n } from '../../../../context/I18nContext';
import { useContact } from '../../../../hooks/useContact';
import { useNavigation } from '../../../../context/NavigationContext';
import ContactDetails from './ContactDetails';
import SearchInput from '../../../SearchInput';
import ConversationList from '../../../ConversationList';
import useSearch from '../../../../hooks/useSearch';
import './ContactView.css';

const ContactView = ({
  contactId = null,
}) => {
  const { t } = useI18n();
  const { navigateToConversation } = useNavigation();

  // Use the new hook to get contact details and shared conversations
  const {
    contact,
    sharedConversations,
    isLoading,
  } = useContact(contactId);

  const {
    searchTerm,
    setSearchTerm,
  } = useSearch();

  // Navigation handler to go to conversation page
  const handleConversationClick = (conversationId) => {
    navigateToConversation(conversationId);
  };

  const [isConversationListOpen, setConversationListOpen] = useState(true);

  const filteredConversations = sharedConversations.filter(conversation => conversation.title.toLowerCase().includes(searchTerm.toLowerCase()));

  if (!contactId || !contact) {
    return <div />;
  }

  return (
    <div className="contactview">
      <div className={`contactview-contact-container ${(isConversationListOpen) ? '' : 'contactview-content-fill'}`}>
        <ContactDetails
          contact={contact}
          onConversationListToggle={() => setConversationListOpen(!isConversationListOpen)}
        />
      </div>
      {
        isConversationListOpen && (
          <div className="contactview-conversation-list-container">
            <div className="contactview-conversation-list-header">
              <SearchInput
                id="contact-conversation-search"
                value={searchTerm}
                placeholderValue={t('SearchInput.search')}
                onChange={setSearchTerm}
                onClearClick={() => setSearchTerm('')}
              />
              <span>{t('ContactConversationsView.conversations')}</span>
            </div>
            <div className="contactview-conversation-list-wrapper">
              <ConversationList
                conversations={filteredConversations}
                onItemClick={handleConversationClick}
                selectedConversationId={null}
                isLoading={isLoading}
              />
            </div>
          </div>
        )
      }
    </div>
  );
};

ContactView.propTypes = {
  contactId: PropTypes.string,
};

export default ContactView;
